import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Loader2 } from 'lucide-angular';

@Component({
  selector: 'app-chat-loading',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './chat-loading.component.html',
  styleUrl: './chat-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatLoadingComponent {
  readonly message = input<string>('Starting your grading session...');

  protected readonly icons = {
    Loader2,
  };
}
